var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("notifications", {
    staticClass: "custom-notification",
    attrs: {
      group: "custom-notification",
      duration: 5000,
      position: "bottom right",
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function (props) {
          return [
            _c("div", { staticClass: "success-template" }, [
              _c("div", { staticClass: "success-template-icon" }, [
                props.item.type === "success"
                  ? _c("div", { staticClass: "success-icon" }, [
                      _c("img", {
                        attrs: {
                          src: "/static/images/icons/check_icon.svg",
                          alt: "check-icon",
                        },
                      }),
                    ])
                  : props.item.type === "error"
                  ? _c("div", { staticClass: "error-icon" }, [
                      _c("img", {
                        attrs: {
                          src: "/static/images/icons/alert_triangle.svg",
                          alt: "alert-icon",
                        },
                      }),
                    ])
                  : _c("div", { staticClass: "warning-icon" }, [
                      _c("img", {
                        attrs: {
                          src: "/static/images/icons/delete_warning.svg",
                          alt: "delete-icon",
                        },
                      }),
                    ]),
              ]),
              _c("div", { staticClass: "success-template-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "title-header",
                    class: {
                      "success-template-title": props.item.type === "success",
                      "error-template-title": props.item.type === "error",
                      "warning-template-title": props.item.type === "warning",
                    },
                  },
                  [_vm._v(" " + _vm._s(props.item.title) + " ")]
                ),
                _c("div", {
                  staticClass: "success-template-text",
                  domProps: { innerHTML: _vm._s(props.item.text) },
                }),
              ]),
              _c(
                "div",
                {
                  staticClass: "success-template-close",
                  on: { click: props.close },
                },
                [
                  _c("img", {
                    attrs: {
                      src: "/static/images/icons/close_icon.svg",
                      alt: "close-icon",
                    },
                  }),
                ]
              ),
            ]),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }